import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Button, Form, Table, InputGroup, Badge, Modal } from 'react-bootstrap';
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaChevronLeft, FaChevronRight, FaCheck, FaGripVertical } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';
import vietnamAddressData from '../utils/vietnamAddressBefore2024.json';
import queryString from 'query-string';
import Pagination from 'components/Pagination';
import { getTKT1ScanPersons, createTKT1ScanPerson, updateTKT1ScanPerson } from 'actions/tkt1ScanPersonAction';
import Select from 'react-select';
import { getApiUrl } from '../utils/platform';
import ImageUploadModal from '../components/ImageUploadModal/ImageUploadModal';

class TKT1ScanPerson extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'MID',
    sortOrder: 1,
    search: '',
    status: '',
    current_city: ''
  }

  initShowColumns = {
    MID: true,
    name: true,
    address: true,
    current_city: true,
    phone: true,
    facebook_link: true,
    google_drive_link: true,
    c3d_number: true,
    c3d_dob: true,
    c3d_sex: true,
    c3d_city: true,
    status: true,
    is_active: true,
    photos: true,
    created_at: false,
    updated_at: false,
    ref_etsy_info_pack_mid: true
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      showEditModal: false,
      showViewModal: false,
      showAddModal: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedScanPerson: null,
      isEditMode: false,
      uploadingImages: false,
      uploadedImages: [],
      showImageUploadModal: false,
      showPhotosModal: false,
      selectedPhotos: [],
      currentPhotoIndex: 0,
      editingDescription: null,
      draggedIndex: null,
      editFormData: {
        name: '',
        address: '',
        current_city: '',
        phone: '',
        facebook_link: '',
        google_drive_link: '',
        contact_note: '',
        photos: [],
        status: 'active',
        ref_etsy_info_pack_mid: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_sex: '',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        c3d_city: '',
        c3d_photos: [],
        c3d_metadata: {},
        is_active: true
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Scan Person';
    
    // Add keyboard event listeners for photo navigation
    this.handleKeyDown = this.handleKeyDown.bind(this);
    document.addEventListener('keydown', this.handleKeyDown);
    
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1ScanPerson_ViewConfig'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1ScanPersons(apiQuery);
      })
    } else {
      // No URL params - use localStorage
      var query = JSON.parse(localStorage.getItem('tkt1_scan_person_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1ScanPerson_ViewConfig'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1ScanPersons(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1ScanPersons(apiQuery);
        })
      }
    }
  }

  componentWillUnmount() {
    // Remove keyboard event listeners
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  // Component methods will be added here...
  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery);
    this.props.getTKT1ScanPersons(apiQuery);
    localStorage.setItem('tkt1_scan_person_query', JSON.stringify(trimmedQuery));
  }

  prepareApiQuery = (query) => {
    const { showColumns, search, status, current_city, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    // Add city filter if selected
    if (current_city && current_city.trim()) {
      apiQuery.current_city = current_city;
    }
    
    return apiQuery;
  }

  updateUrl = (query) => {
    const { history } = this.props;
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1/scan-person',
      search: queryStr,
    });
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      localStorage.setItem('TKT1ScanPerson_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  mapGender = (gender) => {
    if (!gender) return '-';
    switch (gender.toUpperCase()) {
      case 'MALE':
        return 'Nam';
      case 'FEMALE':
        return 'Nữ';
      default:
        return gender;
    }
  }

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  handleImageUpload = async (files) => {
    if (!files || files.length === 0) return;

    this.setState({ uploadingImages: true });

    try {
      const formData = new FormData();
      Array.from(files).forEach(file => {
        formData.append('images', file);
      });

      const response = await fetch(`${getApiUrl()}/api/upload/images`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Upload failed');
      }

      const result = await response.json();
      
      if (result.success && result.data) {
        const newImages = result.data.map(img => ({
          link: img.url,
          description: ''
        }));
        
        this.setState(prevState => ({
          uploadedImages: [...prevState.uploadedImages, ...newImages]
        }));
      }
    } catch (error) {
      console.error('Error uploading images:', error);
      alert('Lỗi khi upload ảnh. Vui lòng thử lại.');
    } finally {
      this.setState({ uploadingImages: false });
    }
  }

  handleImageDescriptionChange = (index, description) => {
    this.setState(prevState => ({
      uploadedImages: prevState.uploadedImages.map((img, i) => 
        i === index ? { ...img, description } : img
      )
    }));
  }

  handleRemoveImage = (index) => {
    this.setState(prevState => ({
      uploadedImages: prevState.uploadedImages.filter((_, i) => i !== index)
    }));
  }

  handleOpenImageUploadModal = () => {
    this.setState({ showImageUploadModal: true });
  }

  handleCloseImageUploadModal = () => {
    this.setState({ showImageUploadModal: false });
  }

  handleImagesUploaded = (newImages) => {
    this.setState(prevState => ({
      uploadedImages: [...prevState.uploadedImages, ...newImages]
    }));
  }

  handlePhotosClick = (photos) => {
    this.setState({
      showPhotosModal: true,
      selectedPhotos: photos || [],
      currentPhotoIndex: 0
    });
  }

  handleClosePhotosModal = () => {
    this.setState({
      showPhotosModal: false,
      selectedPhotos: [],
      currentPhotoIndex: 0
    });
  }

  handlePrevPhoto = () => {
    this.setState(prevState => ({
      currentPhotoIndex: prevState.currentPhotoIndex > 0 
        ? prevState.currentPhotoIndex - 1 
        : prevState.selectedPhotos.length - 1
    }));
  }

  handleNextPhoto = () => {
    this.setState(prevState => ({
      currentPhotoIndex: prevState.currentPhotoIndex < prevState.selectedPhotos.length - 1 
        ? prevState.currentPhotoIndex + 1 
        : 0
    }));
  }

  handleDownloadImage = (imageUrl, fileName) => {
    // Simple approach: Create a link with download attribute
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = fileName || 'image.jpg';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleKeyDown = (e) => {
    // Only handle keyboard events when photos modal is open
    if (!this.state.showPhotosModal) {
      return;
    }

    // Handle navigation keys
    switch (e.key) {
      case 'ArrowLeft':
        if (this.state.selectedPhotos.length > 1) {
          e.preventDefault();
          this.handlePrevPhoto();
        }
        break;
      case 'ArrowRight':
        if (this.state.selectedPhotos.length > 1) {
          e.preventDefault();
          this.handleNextPhoto();
        }
        break;
      case 'Escape':
        e.preventDefault();
        this.handleClosePhotosModal();
        break;
      default:
        break;
    }
  }

  handleEditDescription = (index) => {
    this.setState({ editingDescription: index });
  }

  handleSaveDescription = (index, newDescription) => {
    this.setState(prevState => ({
      uploadedImages: prevState.uploadedImages.map((img, i) => 
        i === index ? { ...img, description: newDescription } : img
      ),
      editingDescription: null
    }));
  }

  handleCancelEditDescription = () => {
    this.setState({ editingDescription: null });
  }

  handleDragStart = (e, index) => {
    this.setState({ draggedIndex: index });
    e.dataTransfer.effectAllowed = 'move';
  }

  handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  }

  handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const { draggedIndex } = this.state;
    
    if (draggedIndex === null || draggedIndex === dropIndex) {
      this.setState({ draggedIndex: null });
      return;
    }

    this.setState(prevState => {
      const newImages = [...prevState.uploadedImages];
      const draggedItem = newImages[draggedIndex];
      
      // Remove dragged item
      newImages.splice(draggedIndex, 1);
      
      // Insert at new position
      const newIndex = draggedIndex < dropIndex ? dropIndex - 1 : dropIndex;
      newImages.splice(newIndex, 0, draggedItem);
      
      return {
        uploadedImages: newImages,
        draggedIndex: null
      };
    });
  }

  handleViewClick = (scanPerson) => {
    this.setState({
      showViewModal: true,
      selectedScanPerson: scanPerson,
      isEditMode: false
    });
  }

  handleEditClick = (scanPerson) => {
    this.setState({
      showEditModal: true,
      selectedScanPerson: scanPerson,
      isEditMode: true,
      uploadedImages: scanPerson.photos || [],
      editFormData: {
        name: scanPerson.name || '',
        address: scanPerson.address || '',
        current_city: scanPerson.current_city || '',
        phone: scanPerson.phone || '',
        facebook_link: scanPerson.facebook_link || '',
        contact_note: scanPerson.contact_note || '',
        photos: scanPerson.photos || [],
        status: scanPerson.status || 'active',
        ref_etsy_info_pack_mid: scanPerson.ref_etsy_info_pack_mid || '',
        c3d_number: scanPerson.c3d_number || '',
        c3d_dob: scanPerson.c3d_dob || '',
        c3d_sex: scanPerson.c3d_sex || '',
        c3d_place_of_origin: scanPerson.c3d_place_of_origin || '',
        c3d_place_of_residence: scanPerson.c3d_place_of_residence || '',
        c3d_city: scanPerson.c3d_city || '',
        c3d_photos: scanPerson.c3d_photos || [],
        c3d_metadata: scanPerson.c3d_metadata || {},
        is_active: scanPerson.is_active !== undefined ? scanPerson.is_active : true
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedScanPerson: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedScanPerson: null,
      isEditMode: false,
      uploadedImages: [],
      editFormData: {
        name: '',
        address: '',
        current_city: '',
        phone: '',
        facebook_link: '',
        google_drive_link: '',
        contact_note: '',
        photos: [],
        status: 'active',
        ref_etsy_info_pack_mid: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_sex: '',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        c3d_city: '',
        c3d_photos: [],
        c3d_metadata: {},
        is_active: true
      }
    });
  }

  handleAddClick = () => {
    this.setState({
      showAddModal: true,
      selectedScanPerson: null,
      isEditMode: false,
      uploadedImages: [],
      editFormData: {
        name: '',
        address: '',
        current_city: '',
        phone: '',
        facebook_link: '',
        google_drive_link: '',
        contact_note: '',
        photos: [],
        status: 'active',
        ref_etsy_info_pack_mid: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_sex: '',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        c3d_city: '',
        c3d_photos: [],
        c3d_metadata: {},
        is_active: true
      }
    });
  }

  handleCloseAddModal = () => {
    this.setState({
      showAddModal: false,
      selectedScanPerson: null,
      isEditMode: false,
      uploadedImages: [],
      editFormData: {
        name: '',
        address: '',
        current_city: '',
        phone: '',
        facebook_link: '',
        google_drive_link: '',
        contact_note: '',
        photos: [],
        status: 'active',
        ref_etsy_info_pack_mid: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_sex: '',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        c3d_city: '',
        c3d_photos: [],
        c3d_metadata: {},
        is_active: true
      }
    });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Etsy Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  handleSaveAdd = async () => {
    const { editFormData, uploadedImages } = this.state;
    
    // Validate required fields
    if (!editFormData.name || editFormData.name.trim() === '') {
      alert('Vui lòng nhập tên!');
      return;
    }
    
    try {
      const dataToSave = {
        ...editFormData,
        photos: uploadedImages
      };
      
      await this.props.createTKT1ScanPerson(dataToSave);
      
      this.handleCloseAddModal();
      
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1ScanPersons(apiQuery);
      
      alert('Thêm Scan Person mới thành công!');
    } catch (error) {
      console.error('Error creating scan person:', error);
      alert('Lỗi khi thêm Scan Person mới. Vui lòng thử lại.');
    }
  }

  handleEditInputChange = (field, value) => {
    this.setState(prevState => ({
      editFormData: {
        ...prevState.editFormData,
        [field]: value
      }
    }));
  }

  handleSaveEdit = async () => {
    const { selectedScanPerson, editFormData, uploadedImages } = this.state;
    
    if (!selectedScanPerson || !selectedScanPerson._id) {
      alert('Không tìm thấy thông tin Scan Person để cập nhật');
      return;
    }

    // Validate required fields
    if (!editFormData.name || editFormData.name.trim() === '') {
      alert('Vui lòng nhập tên!');
      return;
    }

    try {
      const dataToSave = {
        ...editFormData,
        photos: uploadedImages
      };
      
      await this.props.updateTKT1ScanPerson(selectedScanPerson._id, dataToSave);
      
      this.handleCloseEditModal();
      
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1ScanPersons(apiQuery);
      
      alert('Cập nhật thông tin Scan Person thành công!');
    } catch (error) {
      console.error('Error updating scan person:', error);
      alert('Lỗi khi cập nhật thông tin Scan Person. Vui lòng thử lại.');
    }
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim(),
      status: this.state.query.status,
      current_city: this.state.query.current_city
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1ScanPersons(apiQuery);
      localStorage.setItem('tkt1_scan_person_query', JSON.stringify(trimmedQuery));
    })
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage === this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim(),
      status: this.state.query.status,
      current_city: this.state.query.current_city
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ scanPersons: [] }, () => {
        this.updateUrl(trimmedQuery)
        this.props.getTKT1ScanPersons(apiQuery);
        localStorage.setItem('tkt1_scan_person_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    })
  }

  getCityOptions = () => {
    return vietnamAddressData.map((province) => {
      const cleanDisplayName = province.Name
        .replace(/^Tỉnh\s+/, '')
        .replace(/^Thành phố\s+/, '')
        .trim();
      
      return {
        value: cleanDisplayName,
        label: cleanDisplayName
      };
    });
  }

  renderSearchFilter = () => {
    const cityOptions = this.getCityOptions();

    return <>
      <Row className="mb-3">
        <Col md="4">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo tên, MID, số C3D, địa chỉ..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="3">
          <InputGroup>
            <InputGroup.Text>Thành phố</InputGroup.Text>
            <div style={{ flex: 1 }}>
              <Select
                value={cityOptions.find(option => option.value === this.state.query.current_city) || null}
                onChange={(selectedOption) => {
                  const newQuery = { 
                    ...this.state.query, 
                    current_city: selectedOption ? selectedOption.value : '' 
                  };
                  this.setState({ query: newQuery });
                  localStorage.setItem('tkt1_scan_person_query', JSON.stringify(newQuery));
                  
                  const trimmedQuery = {
                    ...newQuery,
                    search: this.state.query.search.trim(),
                    status: this.state.query.status,
                    current_city: newQuery.current_city
                  };
                  const apiQuery = this.prepareApiQuery(trimmedQuery);
                  this.updateUrl(trimmedQuery);
                  this.props.getTKT1ScanPersons(apiQuery);
                }}
                options={cityOptions}
                placeholder="Chọn thành phố..."
                isClearable
                isSearchable
                noOptionsMessage={() => "Không tìm thấy"}
                filterOption={(option, inputValue) => {
                  const searchTerm = inputValue.toLowerCase();
                  const label = option.data.label ? option.data.label.toLowerCase() : '';
                  return label.includes(searchTerm);
                }}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '38px',
                    border: 'none',
                    boxShadow: 'none'
                  }),
                  container: (provided) => ({
                    ...provided,
                    flex: 1
                  })
                }}
              />
            </div>
          </InputGroup>
        </Col>
        <Col md="3">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={(e) => {
                const newQuery = { 
                  ...this.state.query, 
                  status: e.target.value 
                };
                this.setState({ query: newQuery });
                localStorage.setItem('tkt1_scan_person_query', JSON.stringify(newQuery));
                
                const trimmedQuery = {
                  ...newQuery,
                  search: this.state.query.search.trim(),
                  status: newQuery.status,
                  current_city: this.state.query.current_city
                };
                const apiQuery = this.prepareApiQuery(trimmedQuery);
                this.updateUrl(trimmedQuery);
                this.props.getTKT1ScanPersons(apiQuery);
              }}
            >
              <option value="">Tất cả</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSearch}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderScanPersonTable = () => {
    const { scanPersons } = this.props;
    const { showColumns } = this.state;
    
    const safeScanPersons = Array.isArray(scanPersons) ? scanPersons.filter(person => person != null && typeof person === 'object') : [];
    
    if (!safeScanPersons || safeScanPersons.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.MID && <th>MID</th>}
              {showColumns.name && <th>Tên</th>}
              {showColumns.address && <th>Địa chỉ</th>}
              {showColumns.current_city && <th>Thành phố hiện tại</th>}
              {showColumns.phone && <th>Số điện thoại</th>}
              {showColumns.facebook_link && <th>Facebook</th>}
              {showColumns.google_drive_link && <th>Google Drive</th>}
              {showColumns.c3d_number && <th>Số C3D</th>}
              {showColumns.c3d_dob && <th>Ngày sinh C3D</th>}
              {showColumns.c3d_sex && <th>Giới tính C3D</th>}
              {showColumns.c3d_city && <th>Thành phố C3D</th>}
              {showColumns.status && <th>Trạng thái</th>}
              {showColumns.is_active && <th>Hoạt động</th>}
              {showColumns.created_at && <th>Ngày tạo</th>}
              {showColumns.updated_at && <th>Ngày cập nhật</th>}
              {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.MID && <th>MID</th>}
            {showColumns.photos && <th>Ảnh</th>}
            {showColumns.name && <th>Tên</th>}
            {showColumns.address && <th>Địa chỉ</th>}
            {showColumns.current_city && <th>Thành phố hiện tại</th>}
            {showColumns.phone && <th>Số điện thoại</th>}
            {showColumns.facebook_link && <th>Facebook</th>}
            {showColumns.google_drive_link && <th>Google Drive</th>}
            {showColumns.c3d_number && <th>Số C3D</th>}
            {showColumns.c3d_dob && <th>Ngày sinh C3D</th>}
            {showColumns.c3d_sex && <th>Giới tính C3D</th>}
            {showColumns.c3d_city && <th>Thành phố C3D</th>}
            {showColumns.status && <th>Trạng thái</th>}
            {showColumns.is_active && <th>Hoạt động</th>}
            {showColumns.created_at && <th>Ngày tạo</th>}
            {showColumns.updated_at && <th>Ngày cập nhật</th>}
            {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
            <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeScanPersons.map((person, index) => {
            if (!person || typeof person !== 'object') return null;
              
              return (
                <tr key={person._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.MID && (
                    <td>
                      {person.MID ? (
                        <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {person.MID}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.photos && (
                    <td>
                      {person.photos && person.photos.length > 0 ? (
                        <div className="d-flex align-items-center gap-2">
                          <img 
                            src={person.photos[0].link} 
                            alt="Ảnh đầu tiên"
                            style={{ 
                              width: '50px', 
                              height: '50px', 
                              objectFit: 'cover',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              border: '2px solid #dee2e6'
                            }}
                            onClick={() => this.handlePhotosClick(person.photos)}
                            title="Click để xem tất cả ảnh"
                          />
                          {person.photos.length > 1 && (
                            <Badge 
                              bg="info" 
                              style={{ 
                                fontSize: '0.8em', 
                                padding: '4px 8px',
                                cursor: 'pointer'
                              }}
                              onClick={() => this.handlePhotosClick(person.photos)}
                              title="Click để xem tất cả ảnh"
                            >
                              +{person.photos.length - 1}
                            </Badge>
                          )}
                        </div>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                  )}
                  {showColumns.name && (
                    <td>
                      <div className="fw-bold">{person.name || '-'}</div>
                    </td>
                  )}
                  {showColumns.address && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} title={person.address}>
                        {person.address || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.current_city && (
                    <td>{person.current_city || '-'}</td>
                  )}
                  {showColumns.phone && (
                    <td>{person.phone || '-'}</td>
                  )}
                  {showColumns.facebook_link && (
                    <td>
                      {person.facebook_link ? (
                        <a href={person.facebook_link} target="_blank" rel="noopener noreferrer">
                          <FaExternalLinkAlt size={14} /> Link
                        </a>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.google_drive_link && (
                    <td>
                      {person.google_drive_link ? (
                        <a href={person.google_drive_link} target="_blank" rel="noopener noreferrer">
                          <FaExternalLinkAlt size={14} /> Link
                        </a>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.c3d_number && (
                    <td>
                      {person.c3d_number ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{person.c3d_number}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(person.c3d_number)}
                            title="Copy C3D number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.c3d_dob && (
                    <td>{person.c3d_dob || '-'}</td>
                  )}
                  {showColumns.c3d_sex && (
                    <td>{this.mapGender(person.c3d_sex)}</td>
                  )}
                  {showColumns.c3d_city && (
                    <td>{person.c3d_city || '-'}</td>
                  )}
                  {showColumns.status && (
                    <td>
                      {person.status ? (
                        <Badge 
                          bg={
                            person.status === 'active' ? 'success' :
                            person.status === 'inactive' ? 'warning' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {person.status}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.is_active && (
                    <td>
                      <Badge bg={person.is_active ? "success" : "secondary"}>
                        {person.is_active ? "Hoạt động" : "Không hoạt động"}
                      </Badge>
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>
                      {person.created_at ? new Date(person.created_at).toLocaleDateString('vi-VN') : '-'}
                    </td>
                  )}
                  {showColumns.updated_at && (
                    <td>
                      {person.updated_at ? new Date(person.updated_at).toLocaleDateString('vi-VN') : '-'}
                    </td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {person.ref_etsy_info_pack_mid ? (
                        <Badge 
                          bg="success" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => this.handleEtsyInfoPackClick(person.ref_etsy_info_pack_mid)}
                          title="Click để xem chi tiết Etsy Info Pack"
                        >
                          {person.ref_etsy_info_pack_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(person)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(person)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Scan Person
              </h2>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="success" 
                  size="sm"
                  className="me-2"
                  onClick={this.handleAddClick}
                >
                  <i className="fas fa-plus"></i> Add Scan Person
                </Button>
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="table-responsive" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                {this.renderScanPersonTable()}
              </div>
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    MID: 'MID',
                    name: 'Tên',
                    address: 'Địa chỉ',
                    current_city: 'Thành phố hiện tại',
                    phone: 'Số điện thoại',
                    facebook_link: 'Facebook',
                    google_drive_link: 'Google Drive',
                    c3d_number: 'Số C3D',
                    c3d_dob: 'Ngày sinh C3D',
                    c3d_sex: 'Giới tính C3D',
                    c3d_city: 'Thành phố C3D',
                    status: 'Trạng thái',
                    is_active: 'Hoạt động',
                    photos: 'Ảnh',
                    created_at: 'Ngày tạo',
                    updated_at: 'Ngày cập nhật',
                    ref_etsy_info_pack_mid: 'MID Etsy Info Pack'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Scan Person</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedScanPerson && (
              <div>
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedScanPerson.MID || '-'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tên:</strong> 
                    <div className="mt-1 fw-bold">{this.state.selectedScanPerson.name || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Số điện thoại:</strong> 
                    <div className="mt-1">{this.state.selectedScanPerson.phone || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>Facebook:</strong> 
                    <div className="mt-1">
                      {this.state.selectedScanPerson.facebook_link ? (
                        <a href={this.state.selectedScanPerson.facebook_link} target="_blank" rel="noopener noreferrer">
                          <FaExternalLinkAlt size={14} /> Link
                        </a>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Google Drive:</strong> 
                    <div className="mt-1">
                      {this.state.selectedScanPerson.google_drive_link ? (
                        <a href={this.state.selectedScanPerson.google_drive_link} target="_blank" rel="noopener noreferrer">
                          <FaExternalLinkAlt size={14} /> Link
                        </a>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Địa chỉ:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedScanPerson.address || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Thành phố hiện tại:</strong> 
                    <div className="mt-1">{this.state.selectedScanPerson.current_city || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>Ref Etsy Info Pack MID:</strong> 
                    <div className="mt-1">{this.state.selectedScanPerson.ref_etsy_info_pack_mid || '-'}</div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin C3D</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Số C3D:</strong> 
                    <div className="mt-1">
                      {this.state.selectedScanPerson.c3d_number ? (
                        <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {this.state.selectedScanPerson.c3d_number}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày sinh C3D:</strong> 
                    <div className="mt-1">{this.state.selectedScanPerson.c3d_dob || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Giới tính C3D:</strong> 
                    <div className="mt-1">{this.mapGender(this.state.selectedScanPerson.c3d_sex)}</div>
                  </Col>
                  <Col md="6">
                    <strong>Thành phố C3D:</strong> 
                    <div className="mt-1">{this.state.selectedScanPerson.c3d_city || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Nơi sinh C3D:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedScanPerson.c3d_place_of_origin || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Nơi cư trú C3D:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedScanPerson.c3d_place_of_residence || '-'}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái & Ghi chú</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedScanPerson.status ? (
                        <Badge 
                          bg={
                            this.state.selectedScanPerson.status === 'active' ? 'success' :
                            this.state.selectedScanPerson.status === 'inactive' ? 'warning' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.state.selectedScanPerson.status}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Hoạt động:</strong> 
                    <div className="mt-1">
                      <Badge bg={this.state.selectedScanPerson.is_active ? "success" : "secondary"}>
                        {this.state.selectedScanPerson.is_active ? "Có" : "Không"}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú liên hệ:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedScanPerson.contact_note || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày tạo:</strong> 
                    <div className="mt-1">
                      {this.state.selectedScanPerson.created_at ? 
                        new Date(this.state.selectedScanPerson.created_at).toLocaleString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày cập nhật:</strong> 
                    <div className="mt-1">
                      {this.state.selectedScanPerson.updated_at ? 
                        new Date(this.state.selectedScanPerson.updated_at).toLocaleString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>

                {/* Photos Section */}
                {this.state.selectedScanPerson.photos && this.state.selectedScanPerson.photos.length > 0 && (
                  <>
                    <Row className="mb-4">
                      <Col>
                        <h5 className="text-primary">Ảnh đã upload</h5>
                        <hr />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <div className="row">
                          {this.state.selectedScanPerson.photos.map((photo, index) => (
                            <div key={index} className="col-md-4 mb-3">
                              <div className="card">
                                <img 
                                  src={photo.link} 
                                  alt={photo.description || `Ảnh ${index + 1}`}
                                  className="card-img-top"
                                  style={{ height: '200px', objectFit: 'cover' }}
                                />
                                <div className="card-body p-2">
                                  {photo.description && (
                                    <p className="card-text small text-muted mb-0">
                                      {photo.description}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Scan Person</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {(() => {
                const cityOptions = this.getCityOptions();
                return (
                  <>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Tên</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.name}
                            onChange={(e) => this.handleEditInputChange('name', e.target.value)}
                            placeholder="Nhập tên"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Số điện thoại</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.phone}
                            onChange={(e) => this.handleEditInputChange('phone', e.target.value)}
                            placeholder="Nhập số điện thoại"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Địa chỉ</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            value={this.state.editFormData.address}
                            onChange={(e) => this.handleEditInputChange('address', e.target.value)}
                            placeholder="Nhập địa chỉ"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Thành phố hiện tại</Form.Label>
                          <Select
                            value={cityOptions.find(option => option.value === this.state.editFormData.current_city) || null}
                            onChange={(selectedOption) => this.handleEditInputChange('current_city', selectedOption ? selectedOption.value : '')}
                            options={cityOptions}
                            placeholder="Chọn thành phố..."
                            isClearable
                            isSearchable
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Facebook Link</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.facebook_link}
                            onChange={(e) => this.handleEditInputChange('facebook_link', e.target.value)}
                            placeholder="Nhập link Facebook"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Google Drive Link</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.google_drive_link}
                            onChange={(e) => this.handleEditInputChange('google_drive_link', e.target.value)}
                            placeholder="Nhập link Google Drive"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Trạng thái</Form.Label>
                          <Form.Select
                            value={this.state.editFormData.status}
                            onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                          >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Ref Etsy Info Pack MID</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.ref_etsy_info_pack_mid}
                            onChange={(e) => this.handleEditInputChange('ref_etsy_info_pack_mid', e.target.value)}
                            placeholder="Nhập Ref Etsy Info Pack MID"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Ghi chú liên hệ</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={this.state.editFormData.contact_note}
                            onChange={(e) => this.handleEditInputChange('contact_note', e.target.value)}
                            placeholder="Nhập ghi chú liên hệ"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Số C3D</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.c3d_number}
                            onChange={(e) => this.handleEditInputChange('c3d_number', e.target.value)}
                            placeholder="Nhập số C3D"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Ngày sinh C3D</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.c3d_dob}
                            onChange={(e) => this.handleEditInputChange('c3d_dob', e.target.value)}
                            placeholder="Nhập ngày sinh C3D"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Giới tính C3D</Form.Label>
                          <Form.Select
                            value={this.state.editFormData.c3d_sex}
                            onChange={(e) => this.handleEditInputChange('c3d_sex', e.target.value)}
                          >
                            <option value="">Chọn giới tính</option>
                            <option value="MALE">Nam</option>
                            <option value="FEMALE">Nữ</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Thành phố C3D</Form.Label>
                          <Select
                            value={cityOptions.find(option => option.value === this.state.editFormData.c3d_city) || null}
                            onChange={(selectedOption) => this.handleEditInputChange('c3d_city', selectedOption ? selectedOption.value : '')}
                            options={cityOptions}
                            placeholder="Chọn thành phố..."
                            isClearable
                            isSearchable
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Nơi sinh C3D</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            value={this.state.editFormData.c3d_place_of_origin}
                            onChange={(e) => this.handleEditInputChange('c3d_place_of_origin', e.target.value)}
                            placeholder="Nhập nơi sinh C3D"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Nơi cư trú C3D</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            value={this.state.editFormData.c3d_place_of_residence}
                            onChange={(e) => this.handleEditInputChange('c3d_place_of_residence', e.target.value)}
                            placeholder="Nhập nơi cư trú C3D"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Check
                            type="checkbox"
                            id="is_active"
                            label="Hoạt động"
                            checked={this.state.editFormData.is_active}
                            onChange={(e) => this.handleEditInputChange('is_active', e.target.checked)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    
                    {/* Photos Section */}
                    <Row className="mb-4">
                      <Col>
                        <h6 className="text-primary">Ảnh hiện tại</h6>
                        <hr />
                        <div className="border rounded p-3">
                          {this.state.uploadedImages.length > 0 ? (
                            <div className="row">
                              {this.state.uploadedImages.map((image, index) => (
                                <div key={index} className="col-md-4 mb-3">
                                  <div 
                                    className="card"
                                    draggable
                                    onDragStart={(e) => this.handleDragStart(e, index)}
                                    onDragOver={this.handleDragOver}
                                    onDrop={(e) => this.handleDrop(e, index)}
                                    style={{ 
                                      cursor: 'move',
                                      opacity: this.state.draggedIndex === index ? 0.5 : 1,
                                      transition: 'opacity 0.2s'
                                    }}
                                  >
                                    <div className="position-relative">
                                      <img 
                                        src={image.link} 
                                        alt={`Photo ${index + 1}`}
                                        className="card-img-top"
                                        style={{ height: '150px', objectFit: 'cover' }}
                                      />
                                      <div 
                                        className="position-absolute top-0 end-0 m-2"
                                        style={{ 
                                          backgroundColor: 'rgba(0,0,0,0.7)', 
                                          borderRadius: '4px',
                                          padding: '2px 6px'
                                        }}
                                      >
                                        <FaGripVertical size={16} color="white" />
                                      </div>
                                    </div>
                                    <div className="card-body p-2">
                                      {this.state.editingDescription === index ? (
                                        <div>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            defaultValue={image.description}
                                            onKeyPress={(e) => {
                                              if (e.key === 'Enter') {
                                                this.handleSaveDescription(index, e.target.value);
                                              }
                                            }}
                                            onBlur={(e) => this.handleSaveDescription(index, e.target.value)}
                                            autoFocus
                                          />
                                          <div className="mt-1">
                                            <Button
                                              variant="success"
                                              size="sm"
                                              className="me-1"
                                              onClick={(e) => this.handleSaveDescription(index, e.target.previousElementSibling.value)}
                                            >
                                              <FaCheck size={14} />
                                            </Button>
                                            <Button
                                              variant="secondary"
                                              size="sm"
                                              onClick={this.handleCancelEditDescription}
                                            >
                                              <FaTimes size={14} />
                                            </Button>
                                          </div>
                                        </div>
                                      ) : (
                                        <div>
                                          <p className="card-text small text-muted mb-2">
                                            {image.description || 'Không có mô tả'}
                                          </p>
                                          <div className="d-flex gap-1">
                                            <Button
                                              variant="outline-primary"
                                              size="sm"
                                              className="flex-fill"
                                              onClick={() => this.handleEditDescription(index)}
                                            >
                                              <FaEdit size={12} className="me-1" />
                                              Sửa
                                            </Button>
                                            <Button
                                              variant="danger"
                                              size="sm"
                                              className="flex-fill"
                                              onClick={() => this.handleRemoveImage(index)}
                                            >
                                              <FaTrash size={12} className="me-1" />
                                              Xóa
                                            </Button>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center text-muted py-3">
                              <i className="fas fa-images fa-2x mb-2"></i>
                              <p>Chưa có ảnh nào</p>
                            </div>
                          )}
                          
                          <div className="text-center mt-3">
                            <Button
                              variant="primary"
                              onClick={this.handleOpenImageUploadModal}
                            >
                              <i className="fas fa-plus me-2"></i>
                              Thêm ảnh
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                );
              })()}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add Modal */}
        <Modal show={this.state.showAddModal} onHide={this.handleCloseAddModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-plus me-2"></i>
              Thêm Scan Person mới
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {(() => {
                const cityOptions = this.getCityOptions();
                return (
                  <>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Tên *</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.name}
                            onChange={(e) => this.handleEditInputChange('name', e.target.value)}
                            placeholder="Nhập tên"
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Số điện thoại</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.phone}
                            onChange={(e) => this.handleEditInputChange('phone', e.target.value)}
                            placeholder="Nhập số điện thoại"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Địa chỉ</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            value={this.state.editFormData.address}
                            onChange={(e) => this.handleEditInputChange('address', e.target.value)}
                            placeholder="Nhập địa chỉ"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Thành phố hiện tại</Form.Label>
                          <Select
                            value={cityOptions.find(option => option.value === this.state.editFormData.current_city) || null}
                            onChange={(selectedOption) => this.handleEditInputChange('current_city', selectedOption ? selectedOption.value : '')}
                            options={cityOptions}
                            placeholder="Chọn thành phố..."
                            isClearable
                            isSearchable
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Facebook Link</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.facebook_link}
                            onChange={(e) => this.handleEditInputChange('facebook_link', e.target.value)}
                            placeholder="Nhập link Facebook"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Google Drive Link</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.google_drive_link}
                            onChange={(e) => this.handleEditInputChange('google_drive_link', e.target.value)}
                            placeholder="Nhập link Google Drive"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Trạng thái</Form.Label>
                          <Form.Select
                            value={this.state.editFormData.status}
                            onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                          >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Ref Etsy Info Pack MID</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.ref_etsy_info_pack_mid}
                            onChange={(e) => this.handleEditInputChange('ref_etsy_info_pack_mid', e.target.value)}
                            placeholder="Nhập Ref Etsy Info Pack MID"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Ghi chú liên hệ</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={this.state.editFormData.contact_note}
                            onChange={(e) => this.handleEditInputChange('contact_note', e.target.value)}
                            placeholder="Nhập ghi chú liên hệ"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Số C3D</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.c3d_number}
                            onChange={(e) => this.handleEditInputChange('c3d_number', e.target.value)}
                            placeholder="Nhập số C3D"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Ngày sinh C3D</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.editFormData.c3d_dob}
                            onChange={(e) => this.handleEditInputChange('c3d_dob', e.target.value)}
                            placeholder="Nhập ngày sinh C3D"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Giới tính C3D</Form.Label>
                          <Form.Select
                            value={this.state.editFormData.c3d_sex}
                            onChange={(e) => this.handleEditInputChange('c3d_sex', e.target.value)}
                          >
                            <option value="">Chọn giới tính</option>
                            <option value="MALE">Nam</option>
                            <option value="FEMALE">Nữ</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Thành phố C3D</Form.Label>
                          <Select
                            value={cityOptions.find(option => option.value === this.state.editFormData.c3d_city) || null}
                            onChange={(selectedOption) => this.handleEditInputChange('c3d_city', selectedOption ? selectedOption.value : '')}
                            options={cityOptions}
                            placeholder="Chọn thành phố..."
                            isClearable
                            isSearchable
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Nơi sinh C3D</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            value={this.state.editFormData.c3d_place_of_origin}
                            onChange={(e) => this.handleEditInputChange('c3d_place_of_origin', e.target.value)}
                            placeholder="Nhập nơi sinh C3D"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Nơi cư trú C3D</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            value={this.state.editFormData.c3d_place_of_residence}
                            onChange={(e) => this.handleEditInputChange('c3d_place_of_residence', e.target.value)}
                            placeholder="Nhập nơi cư trú C3D"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6">
                        <Form.Group>
                          <Form.Check
                            type="checkbox"
                            id="is_active_add"
                            label="Hoạt động"
                            checked={this.state.editFormData.is_active}
                            onChange={(e) => this.handleEditInputChange('is_active', e.target.checked)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    
                    {/* Photos Section */}
                    <Row className="mb-4">
                      <Col>
                        <h6 className="text-primary">Ảnh hiện tại</h6>
                        <hr />
                        <div className="border rounded p-3">
                          {this.state.uploadedImages.length > 0 ? (
                            <div className="row">
                              {this.state.uploadedImages.map((image, index) => (
                                <div key={index} className="col-md-4 mb-3">
                                  <div 
                                    className="card"
                                    draggable
                                    onDragStart={(e) => this.handleDragStart(e, index)}
                                    onDragOver={this.handleDragOver}
                                    onDrop={(e) => this.handleDrop(e, index)}
                                    style={{ 
                                      cursor: 'move',
                                      opacity: this.state.draggedIndex === index ? 0.5 : 1,
                                      transition: 'opacity 0.2s'
                                    }}
                                  >
                                    <div className="position-relative">
                                      <img 
                                        src={image.link} 
                                        alt={`Photo ${index + 1}`}
                                        className="card-img-top"
                                        style={{ height: '150px', objectFit: 'cover' }}
                                      />
                                      <div 
                                        className="position-absolute top-0 end-0 m-2"
                                        style={{ 
                                          backgroundColor: 'rgba(0,0,0,0.7)', 
                                          borderRadius: '4px',
                                          padding: '2px 6px'
                                        }}
                                      >
                                        <FaGripVertical size={16} color="white" />
                                      </div>
                                    </div>
                                    <div className="card-body p-2">
                                      {this.state.editingDescription === index ? (
                                        <div>
                                          <Form.Control
                                            type="text"
                                            size="sm"
                                            defaultValue={image.description}
                                            onKeyPress={(e) => {
                                              if (e.key === 'Enter') {
                                                this.handleSaveDescription(index, e.target.value);
                                              }
                                            }}
                                            onBlur={(e) => this.handleSaveDescription(index, e.target.value)}
                                            autoFocus
                                          />
                                          <div className="mt-1">
                                            <Button
                                              variant="success"
                                              size="sm"
                                              className="me-1"
                                              onClick={(e) => this.handleSaveDescription(index, e.target.previousElementSibling.value)}
                                            >
                                              <FaCheck size={14} />
                                            </Button>
                                            <Button
                                              variant="secondary"
                                              size="sm"
                                              onClick={this.handleCancelEditDescription}
                                            >
                                              <FaTimes size={14} />
                                            </Button>
                                          </div>
                                        </div>
                                      ) : (
                                        <div>
                                          <p className="card-text small text-muted mb-2">
                                            {image.description || 'Không có mô tả'}
                                          </p>
                                          <div className="d-flex gap-1">
                                            <Button
                                              variant="outline-primary"
                                              size="sm"
                                              className="flex-fill"
                                              onClick={() => this.handleEditDescription(index)}
                                            >
                                              <FaEdit size={12} className="me-1" />
                                              Sửa
                                            </Button>
                                            <Button
                                              variant="danger"
                                              size="sm"
                                              className="flex-fill"
                                              onClick={() => this.handleRemoveImage(index)}
                                            >
                                              <FaTrash size={12} className="me-1" />
                                              Xóa
                                            </Button>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center text-muted py-3">
                              <i className="fas fa-images fa-2x mb-2"></i>
                              <p>Chưa có ảnh nào</p>
                            </div>
                          )}
                          
                          <div className="text-center mt-3">
                            <Button
                              variant="primary"
                              onClick={this.handleOpenImageUploadModal}
                            >
                              <i className="fas fa-plus me-2"></i>
                              Thêm ảnh
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                );
              })()}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAddModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveAdd}>
              <i className="fas fa-save me-1"></i>
              Thêm mới
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />

        {/* Image Upload Modal */}
        <ImageUploadModal
          show={this.state.showImageUploadModal}
          onHide={this.handleCloseImageUploadModal}
          onImagesUploaded={this.handleImagesUploaded}
          title="Upload Ảnh"
          maxImages={10}
          existingImages={this.state.uploadedImages}
        />

        {/* Photos Modal */}
        <Modal show={this.state.showPhotosModal} onHide={this.handleClosePhotosModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-images me-2"></i>
              Xem ảnh ({this.state.currentPhotoIndex + 1}/{this.state.selectedPhotos.length})
            </Modal.Title>
          </Modal.Header>
          {this.state.selectedPhotos.length > 1 && (
            <div className="text-center text-muted small mb-2" style={{ backgroundColor: '#f8f9fa', padding: '8px' }}>
              <i className="fas fa-keyboard me-1"></i>
              Sử dụng phím mũi tên ← → để điều hướng, ESC để đóng
            </div>
          )}
          <Modal.Body>
            {this.state.selectedPhotos.length > 0 ? (
              <div className="text-center">
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img 
                    src={this.state.selectedPhotos[this.state.currentPhotoIndex].link} 
                    alt={this.state.selectedPhotos[this.state.currentPhotoIndex].description || `Ảnh ${this.state.currentPhotoIndex + 1}`}
                    style={{ 
                      maxWidth: '100%', 
                      maxHeight: '70vh', 
                      objectFit: 'contain',
                      borderRadius: '8px'
                    }}
                  />
                  
                  {/* Navigation arrows */}
                  {this.state.selectedPhotos.length > 1 && (
                    <>
                      <div
                        style={{
                          position: 'absolute',
                          left: '-60px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={this.handlePrevPhoto}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = 'rgba(255,255,255,1)';
                          e.target.style.transform = 'translateY(-50%) scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'rgba(255,255,255,0.9)';
                          e.target.style.transform = 'translateY(-50%) scale(1)';
                        }}
                      >
                        <FaChevronLeft size={24} color="#333" />
                      </div>
                      <div
                        style={{
                          position: 'absolute',
                          right: '-60px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={this.handleNextPhoto}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = 'rgba(255,255,255,1)';
                          e.target.style.transform = 'translateY(-50%) scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'rgba(255,255,255,0.9)';
                          e.target.style.transform = 'translateY(-50%) scale(1)';
                        }}
                      >
                        <FaChevronRight size={24} color="#333" />
                      </div>
                    </>
                  )}
                </div>
                
                {/* Photo description */}
                {this.state.selectedPhotos[this.state.currentPhotoIndex].description && (
                  <div className="mt-3">
                    <p className="text-muted mb-0">
                      {this.state.selectedPhotos[this.state.currentPhotoIndex].description}
                    </p>
                  </div>
                )}
                
                {/* Action buttons */}
                <div className="mt-3 d-flex gap-2 justify-content-center">
                  <Button
                    variant="primary"
                    onClick={() => window.open(this.state.selectedPhotos[this.state.currentPhotoIndex].link, '_blank')}
                  >
                    <i className="fas fa-external-link-alt me-1"></i>
                    Xem full size
                  </Button>
                  <Button
                    variant="success"
                    onClick={() => this.handleDownloadImage(
                      this.state.selectedPhotos[this.state.currentPhotoIndex].link, 
                      `photo_${this.state.currentPhotoIndex + 1}.jpg`
                    )}
                  >
                    <i className="fas fa-download me-1"></i>
                    Tải về
                  </Button>
                </div>
              </div>
            ) : (
              <div className="text-center text-muted py-4">
                <i className="fas fa-images fa-3x mb-3"></i>
                <p>Không có ảnh nào</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClosePhotosModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    scanPersons: state.tkt1ScanPersonReducer.scanPersons,
    totalCount: state.tkt1ScanPersonReducer.totalCount
  };
};

export default connect(mapStateToProps, { getTKT1ScanPersons, createTKT1ScanPerson, updateTKT1ScanPerson })(TKT1ScanPerson);

// Add CSS for drag functionality, icon fixes, and sticky header
const dragStyles = `
  .drag-handle {
    cursor: move;
    transition: all 0.2s ease;
  }
  .drag-handle:hover {
    transform: scale(1.05);
  }
  .dragging {
    opacity: 0.5;
    transform: rotate(2deg);
  }
  
  /* Ensure React Icons display properly */
  svg {
    display: inline-block;
    vertical-align: middle;
  }
  
  /* Fix button icon alignment */
  .btn svg {
    margin: 0;
    padding: 0;
  }
  
  /* Sticky table header */
  .table thead th {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: white;
    border-bottom: 2px solid #dee2e6;
  }
  
  /* Ensure table container has proper overflow */
  .table-responsive {
    max-height: 80vh;
    overflow-y: auto;
  }
`;

// Inject CSS
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = dragStyles;
  document.head.appendChild(style);
}
